<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" clearable :placeholder="$t('menu.FrameNumber') + '/' + $t('menu.EngineNumber')"
          v-model="formInline.searchValue"></el-input>
      </el-form-item>
     
    
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
      
      </el-form-item>
    </el-form>
   
    <el-table  empty-text=" " :data="mation" style="width: 100%" :empty-text=" $t('menu.zwshj')" stripe border highlight-current-row>
      <el-table-column prop="mcVersionId"  :label="$t('menu.Vehicle')" min-width="140">
        <template slot-scope="scope">
          {{ motosale(scope.row.mcSeriesModel) }}
        </template>
      </el-table-column>
      <el-table-column prop="chassisNumber" :label="$t('menu.FrameNumber')" min-width="140"> </el-table-column>
      <el-table-column prop="engineNumber" :label="$t('menu.EngineNumber')" min-width="140"></el-table-column>
        <el-table-column prop="retailerId" :label="$t('menu.cldasclss')" min-width="140"></el-table-column>
      <el-table-column prop="status" :label="$t('menu.State')" min-width="100">
        <template slot-scope="scope">
          {{ teck(scope.row.status) }}
        </template>
      </el-table-column>
     
      <el-table-column :label="$t('menu.Operation')" min-width="80">
        <template slot-scope="scope">
         
          <el-button type="text" size="mini" @click="handleEdit(2, scope.row)" >{{ $t('menu.Details')
            }}</el-button>
       
        </template>
      </el-table-column>
    </el-table>

    

 
  </div>
</template>
  
  <script>
import { getInfo,mcVehicleOfDealerLista,listMcSeriesModels,querytype } from "../../api/api";

export default {
  data () {
    return {
      userId: null,
   
      mation: [], //列表
      cartypelist: [],
      formInline: {
        searchValue: "",
       
      },
    
      iszh:sessionStorage.getItem('i18n'),
   
    };
  },
  created () {
    // this.listMcSeriesModel()
    // this.getList()
    this.getQuerytype()
  },
 
  methods: {
    
   
    //查询车辆列表
    getList () {
   
      let params = 'searchValue=' + this.formInline.searchValue 
      mcVehicleOfDealerLista(params).then(res => {
        if (res.data.code == 200) {
          this.mation = res.data.rows
          this.totale = res.data.total
        }
      })
    },
   
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();
      const { data: res } = await listMcSeriesModels(param);
      this.cartypelist = res.data;
    },
    teck (e) {
      if (e == 'Unregistered') {
        return this.$t('menu.Unregistered')
      } else {
        return this.$t('menu.Registered')
      }
    },
    motosale (e) {
      let a = this.cartypelist
      let b =''
      if(e!==null){
        a.forEach(z=>{
          if(z.dictValue == e){

            b= this.iszh=='zh'?z.dictLabel:z.dictLabelEn
          }
        })
      }
      return b
    },
 
    //搜索
    onSubmit () {
      if(this.formInline.searchValue!==""){
         this.getList()
      }
     
    },
  
  handleEdit (index, row) {
      let a = sessionStorage.getItem('name')
      let b = sessionStorage.getItem('namef')
      sessionStorage.setItem('namefac1',a )
      sessionStorage.setItem('namefac2',b )
      let cc  =sessionStorage.getItem('i18n')
      if (cc !== 'zh') {
        sessionStorage.setItem('name', 'Details')
        sessionStorage.setItem('namef', '订单详情')

      } else {
        sessionStorage.setItem('name', '订单详情')
        sessionStorage.setItem('namef', 'Details')
      }
      this.$router.push({
        path: "/archcont",
        query: {
          id: row.id,
          index: index
        },
      });
    },
    getQuerytype () {
      const params = new URLSearchParams()
      querytype( params, 't_mc_series_model').then(r => {
        console.log(r);
        this.cartypelist = r.data.data;
        // if (r.data.code == 200) {
        //   r.data.data.forEach(i => {
        //     if (this.iszh !== 'zh') {
        //       i.dictLabel = i.dictLabelEn
        //     }
        //     this.titleList.push(i)
        //   })
        // }
      })
    },
    
  
  },
};
</script>

<style lang="less" scoped>

</style>